var Locales = /* @__PURE__ */ ((Locales2) => {
  Locales2["en-IO"] = "en-IO";
  Locales2["ca-ES"] = "ca-ES";
  Locales2["da-DK"] = "da-DK";
  Locales2["en-GB"] = "en-GB";
  Locales2["es-ES"] = "es-ES";
  Locales2["fr-BE"] = "fr-BE";
  Locales2["it-IT"] = "it-IT";
  Locales2["nl-BE"] = "nl-BE";
  Locales2["nl-NL"] = "nl-NL";
  Locales2["pt-PT"] = "pt-PT";
  Locales2["sv-SE"] = "sv-SE";
  Locales2["en-IE"] = "en-IE";
  Locales2["fr-FR"] = "fr-FR";
  Locales2["de-DE"] = "de-DE";
  Locales2["de-AT"] = "de-AT";
  Locales2["nb-NO"] = "nb-NO";
  Locales2["de-CH"] = "de-CH";
  Locales2["fr-CH"] = "fr-CH";
  Locales2["it-CH"] = "it-CH";
  Locales2["en-CH"] = "en-CH";
  return Locales2;
})(Locales || {});
var Countries = /* @__PURE__ */ ((Countries2) => {
  Countries2["BE"] = "BE";
  Countries2["DK"] = "DK";
  Countries2["ES"] = "ES";
  Countries2["GB"] = "GB";
  Countries2["IO"] = "IO";
  Countries2["IT"] = "IT";
  Countries2["NL"] = "NL";
  Countries2["PT"] = "PT";
  Countries2["SE"] = "SE";
  Countries2["IE"] = "IE";
  Countries2["FR"] = "FR";
  Countries2["DE"] = "DE";
  Countries2["AT"] = "AT";
  Countries2["BG"] = "BG";
  Countries2["HR"] = "HR";
  Countries2["CY"] = "CY";
  Countries2["CZ"] = "CZ";
  Countries2["EE"] = "EE";
  Countries2["FI"] = "FI";
  Countries2["GR"] = "GR";
  Countries2["HU"] = "HU";
  Countries2["LU"] = "LU";
  Countries2["LV"] = "LV";
  Countries2["LT"] = "LT";
  Countries2["MT"] = "MT";
  Countries2["PL"] = "PL";
  Countries2["SK"] = "SK";
  Countries2["SI"] = "SI";
  Countries2["RO"] = "RO";
  Countries2["NO"] = "NO";
  Countries2["CH"] = "CH";
  return Countries2;
})(Countries || {});
var Currencies = /* @__PURE__ */ ((Currencies2) => {
  Currencies2["EUR"] = "EUR";
  Currencies2["GBP"] = "GBP";
  Currencies2["USD"] = "USD";
  Currencies2["SEK"] = "SEK";
  Currencies2["DKK"] = "DKK";
  Currencies2["NOK"] = "NOK";
  Currencies2["CHF"] = "CHF";
  return Currencies2;
})(Currencies || {});
var Regions = /* @__PURE__ */ ((Regions2) => {
  Regions2["EU"] = "EU";
  Regions2["US"] = "US";
  return Regions2;
})(Regions || {});
export {
  Countries,
  Currencies,
  Locales,
  Regions
};
//# sourceMappingURL=intl.js.map
